import {
  tabs,payment_cards,payment_rows,budget_cards,
  budget_rows,override_rows,irregular_cards,irregular_rows,
  budget_status_options,override_status_options,irregular_type_options,irregular_status_options,initial_sequences
} from './finance_compliance_data';
import { payment_drawers, create_pending_payment_drawer } from './finance_compliance_drawers';
import {
  create_invoice_form,create_budget_form,create_override_form,create_irregular_form,
  amount_to_currency,invoice_to_key,build_budget_row,build_override_row,build_irregular_row
} from './finance_compliance_helpers';
import {
  build_budget_modal_form,
  build_irregular_modal_form,
  build_override_modal_form,
  initialize_finance_sequences,
  next_budget_row,
  next_irregular_row,
  override_row_for_submit
} from './finance_compliance_modal_helpers';
import {
  finance_ui_methods,finance_overlay_watch,
  finance_mounted,finance_before_destroy
} from './finance_compliance_ui';

let invoice_sequence = initial_sequences.invoice;

function next_invoice_id() {
  invoice_sequence += 1;
  const invoice_id = `INV-${invoice_sequence}`;
  return invoice_id;
}

initialize_finance_sequences(initial_sequences);

export default {
  name: 'ComplyonFinance',
  data: () => ({
    tabs,
    active_tab: 'payment_gate',
    payment_cards,
    payment_rows,
    payment_drawers,
    budget_cards,
    budget_rows,
    override_rows,
    irregular_cards,
    irregular_rows,
    budget_status_options,
    override_status_options,
    irregular_type_options,
    irregular_status_options,
    active_drawer_key: null,
    invoice_modal_open: false,
    invoice_form: create_invoice_form(),
    budget_modal_open: false,
    budget_modal_mode: 'create',
    budget_modal_index: null,
    budget_form: create_budget_form(),
    override_modal_open: false,
    override_modal_mode: 'create',
    override_modal_index: null,
    override_form: create_override_form(),
    irregular_modal_open: false,
    irregular_modal_mode: 'create',
    irregular_modal_index: null,
    irregular_form: create_irregular_form()
  }),
  computed: {
    active_drawer() {
      return Reflect.get(this.payment_drawers, this.active_drawer_key) || null;
    }
  },
  methods: {
    ...finance_ui_methods,
    set_tab(tab_id) {
      this.active_tab = tab_id;
      this.active_drawer_key = null;
      this.close_all_modals();
    },
    open_invoice_modal() {
      this.close_drawer();
      this.close_all_modals();
      this.invoice_form = create_invoice_form();
      this.invoice_modal_open = true;
      this.sync_overlay_state();
    },
    close_invoice_modal() {
      this.invoice_modal_open = false;
      this.sync_overlay_state();
    },
    submit_invoice_modal() {
      const supplier = (this.invoice_form.supplier || '').trim() || 'Supplier name';
      const invoice = next_invoice_id();
      const drawer_key = invoice_to_key(invoice);
      const amount = amount_to_currency(this.invoice_form.amount);
      this.payment_rows.unshift({
        invoice,
        supplier,
        amount,
        gate: ['slate', 'slate', 'slate', 'slate', 'slate', 'slate', 'slate'],
        verdict: { label: 'Pending gate', class: 'bg-warning-subtle text-warning-emphasis' },
        drawer_key,
        highlighted: true
      });

      this.$set(this.payment_drawers, drawer_key, create_pending_payment_drawer(invoice, this.invoice_form, amount));
      this.close_invoice_modal();
      this.open_drawer(drawer_key);
    },
    open_budget_modal() {
      this.close_drawer();
      this.close_all_modals();
      this.budget_modal_mode = 'create';
      this.budget_modal_index = null;
      this.budget_form = create_budget_form();
      this.budget_modal_open = true;
      this.sync_overlay_state();
    },
    open_edit_budget_modal(row) {
      const index = this.budget_rows.findIndex((item) => item.id === row.id);
      if (index === -1) return;
      this.close_drawer();
      this.close_all_modals();
      this.budget_modal_mode = 'edit';
      this.budget_modal_index = index;
      this.budget_form = build_budget_modal_form(row);
      this.budget_modal_open = true;
      this.sync_overlay_state();
    },
    close_budget_modal() {
      this.budget_modal_open = false;
      this.budget_modal_mode = 'create';
      this.budget_modal_index = null;
      this.sync_overlay_state();
    },
    submit_budget_modal() {
      const is_edit =
        this.budget_modal_mode === 'edit' &&
        this.budget_modal_index !== null;
      const existing_row = next_budget_row(is_edit, this.budget_modal_index, this.budget_rows);
      const row = build_budget_row(this.budget_form, existing_row);

      if (this.budget_modal_mode === 'edit' && this.budget_modal_index !== null) {
        this.$set(this.budget_rows, this.budget_modal_index, row);
      } else {
        this.budget_rows.unshift(row);
      }
      this.close_budget_modal();
    },
    delete_budget_modal() {
      if (this.budget_modal_mode !== 'edit' || this.budget_modal_index === null) {
        return;
      }
      this.budget_rows.splice(this.budget_modal_index, 1);
      this.close_budget_modal();
    },
    open_override_modal() {
      this.close_drawer();
      this.close_all_modals();
      this.override_modal_mode = 'create';
      this.override_modal_index = null;
      this.override_form = create_override_form();
      this.override_modal_open = true;
      this.sync_overlay_state();
    },
    open_edit_override_modal(row) {
      const index = this.override_rows.findIndex((item) => item.id === row.id);
      if (index === -1) {
        return;
      }

      this.close_drawer();
      this.close_all_modals();
      this.override_modal_mode = 'edit';
      this.override_modal_index = index;
      this.override_form = build_override_modal_form(row);
      this.override_modal_open = true;
      this.sync_overlay_state();
    },
    close_override_modal() {
      this.override_modal_open = false;
      this.override_modal_mode = 'create';
      this.override_modal_index = null;
      this.sync_overlay_state();
    },
    submit_override_modal() {
      const existing_row = override_row_for_submit(this);
      const row = build_override_row(this.override_form, existing_row);

      if (this.override_modal_mode === 'edit' && this.override_modal_index !== null) {
        this.$set(this.override_rows, this.override_modal_index, row);
      } else {
        this.override_rows.unshift(row);
      }

      this.close_override_modal();
    },
    delete_override_modal() {
      if (this.override_modal_mode !== 'edit' || this.override_modal_index === null) {
        return;
      }
      this.override_rows.splice(this.override_modal_index, 1);
      this.close_override_modal();
    },
    open_irregular_modal() {
      this.close_drawer();
      this.close_all_modals();
      this.irregular_modal_mode = 'create';
      this.irregular_modal_index = null;
      this.irregular_form = create_irregular_form();
      this.irregular_modal_open = true;
      this.sync_overlay_state();
    },
    open_edit_irregular_modal(row) {
      const index = this.irregular_rows.findIndex((item) => item.id === row.id);
      if (index === -1) {
        return;
      }

      this.close_drawer();
      this.close_all_modals();
      this.irregular_modal_mode = 'edit';
      this.irregular_modal_index = index;
      this.irregular_form = build_irregular_modal_form(row);
      this.irregular_modal_open = true;
      this.sync_overlay_state();
    },
    close_irregular_modal() {
      this.irregular_modal_open = false;
      this.irregular_modal_mode = 'create';
      this.irregular_modal_index = null;
      this.sync_overlay_state();
    },
    submit_irregular_modal() {
      const is_edit = this.irregular_modal_mode === 'edit' && this.irregular_modal_index !== null;
      const existing_row = next_irregular_row(is_edit, this.irregular_modal_index, this.irregular_rows);
      const row = build_irregular_row(this.irregular_form, existing_row);

      if (is_edit) {
        this.$set(this.irregular_rows, this.irregular_modal_index, row);
      } else {
        this.irregular_rows.unshift(row);
      }

      this.close_irregular_modal();
    },
    delete_irregular_modal() {
      if (this.irregular_modal_mode !== 'edit' || this.irregular_modal_index === null) {
        return;
      }

      this.irregular_rows.splice(this.irregular_modal_index, 1);
      this.close_irregular_modal();
    }
  },
  mounted: finance_mounted,
  beforeDestroy: finance_before_destroy,
  watch: finance_overlay_watch
};
